<template>
    <div>
        <table-page
            :client="client"
            @updated="getDeductions"
            :warnings="warnings"
            :changelogs="changelogs"
            :hideTabs="true"
        >
            <fast-table
                :recordLabel="recordLabel"
                :sections="sections"
                :headers="headers"
                :data="tableData"
                :activeRowId="currentDeductionId"
                @click="currentDeductionId = $event.id"
            >
                <template v-slot:table-actions>
                    <button class="btn btn-primary btn-collapse" id="addDeductionButton" @click="openAddDeductionModal">
                        <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Deduction</span>
                    </button>
                </template>
            </fast-table>

            <add-deduction-modal v-if="addDeductionModalOpen" :client="client" :clientDeductionTypes="deductions" ref="addDeductionModal" @updated="getDeductions" @close="addDeductionModalOpen = false"/>
        </table-page>

        <deduction-sidebar
            v-if="currentDeduction"
            :client="client"
            :deduction-id="currentDeduction.id"
            ref="deductionSidebar"
            @updated="getDeductions"
            @close="currentDeductionId = null"
        >
        </deduction-sidebar>
    </div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import DeductionSidebar from './components/Deductions/DeductionSidebar'
import AddDeductionModal from './components/Deductions/AddDeductionModal'

export default {
    components: {FastTable, DeductionSidebar, AddDeductionModal},
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        currentDeduction() {
            return this.deductions.find(e => (e.id == this.currentDeductionId))
        },
        sections() {
            let sections = [
                {title: 'Active', defaultIsClosed: false, id: 'active', hasDateFilter: false},
                {title: 'Inactive', defaultIsClosed: true, id: 'inactive', hasDateFilter: true},
            ]
            return sections
        },
        activeDeductions() {
            return this.deductions.filter((p) => {return p.is_active})
        },
        inactiveDeductions() {
            return this.deductions.filter((p) => {return !p.is_active})
        },
        tableData() {
            const tableData = []
            const subsets = [
                this.activeDeductions,
                this.inactiveDeductions,
            ]

            subsets.forEach(deductions => {
                const sectionData = []

                deductions.forEach(deduction => {
                    sectionData.push({
                        id: deduction.id,
                        object: deduction,
                        cells: this.makeDeductionTableData(deduction),
                    })
                })
                tableData.push(sectionData)
            })
            return tableData
        },
    },
    data() {
        return {
            deductions: [],
            dataLoaded: false,
            currentDeductionId: null,
            recordLabel: "Deductions",
            headers: [
                {label: 'Company', classes: 'cell-company', isFilterable: true, isSearchable: false, defaultSort: true},
                {label: 'Deduction Name', classes: '', isSearchable: true, isFilterable: true},
                {label: 'Category', classes: '', isSearchable: false, isFilterable: true},
                {label: 'Positions', classes: 'cw-4', isSearchable: false},
            ],
            addDeductionModalOpen: false
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Deductions')
        this.getDeductions()
    },
    methods: {
        getDeductions() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/deduction-types`).then(resp => {
                this.deductions = resp.filter(d => {
                    return !['deferred-comp', 'insurance', 'retirement-loan'].includes(d.deduction_type.category)
                })
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
        makeDeductionTableData(deduction) {
            return [
                deduction.company.name,
                deduction.name,
                deduction.deduction_type.category_pretty,
                deduction.num_positions,
            ]
        },
        openAddDeductionModal() {
            this.addDeductionModalOpen = true
        }
    },
}
</script>
